// Sample articles data - can be moved to a separate data file later
export const ARTICLES_DATA = [
  {
    id: 1,
    slug: "website-development-services-india",
    title: "Website Development Services for Businesses in 2026",
    description: "Professional website development company in India offering custom web applications, React, Node.js, cloud deployment & SEO-optimized solutions for SMEs and enterprises.",
    category: "IT Services",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    publishedDate: "2026-01-15",
    hasFullContent: true
  },
  {
    id: 2,
    slug: "mobile-app-development-flutter-react-native",
    title: "Mobile App Development for iOS & Android",
    description: "Leading mobile app development company in India. We build iOS & Android apps using Flutter, React Native, Swift, Kotlin & more. Serving businesses nationwide.",
    category: "IT Services",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&q=80",
    publishedDate: "2026-01-10",
    hasFullContent: true
  },
  {
    id: 3,
    slug: "help-desk-support-services-india",
    title: "24/7 Help Desk Support Services",
    description: "Outsourced Help Desk Support services in India — L1, L2 & L3 IT support with SLA-backed response times, 24/7 coverage, remote & on-site assistance.",
    category: "IT Services",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=800&q=80",
    publishedDate: "2026-01-05",
    hasFullContent: true
  },
  {
    id: 4,
    slug: "10-signs-its-time-to-switch-your-vendor",
    title: "10 Signs It's Time to Switch Your Vendor",
    description: "Discover the key indicators that suggest it's time to find a better vendor partner for your business growth.",
    category: "Business Strategy",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    publishedDate: "2024-03-15",
    hasFullContent: false
  },
  {
    id: 5,
    slug: "how-to-reduce-office-supply-costs",
    title: "How to Reduce Office Supply Costs by 40%",
    description: "Proven strategies to cut your office supply expenses without compromising on quality or employee satisfaction.",
    category: "Cost Optimization",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    publishedDate: "2024-03-10",
    hasFullContent: false
  },
  {
    id: 6,
    slug: "complete-guide-to-gst-compliance",
    title: "Complete Guide to GST Compliance in 2024",
    description: "Everything you need to know about GST filing deadlines, input tax credits, and avoiding penalties.",
    category: "Compliance",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80",
    publishedDate: "2024-03-05",
    hasFullContent: false
  }
];

export const ARTICLE_CATEGORIES = [
  { label: "Business Strategy", color: "#dc2626" },
  { label: "Cost Optimization", color: "#16a34a" },
  { label: "Compliance", color: "#3b82f6" },
  { label: "IT Services", color: "#7c3aed" },
  { label: "Manpower", color: "#ea580c" }
];
